<template></template>

<script>
export default {
  props: ["chartData", "chartRadius"],
  data(){
    return {
      chartInstance: null
    }
  },
  beforeDestroy() {
    this.chartInstance && this.chartInstance.dispose();
  },
  mounted() {
    import(/* webpackChunkName: "echarts" */"../../helpers/echarts").then(({default: echarts}) => {
      this.chartInstance = echarts.init(this.$el)
      this.update()
    })
  },
  watch: {
    chartData() {
      if (!this.chartInstance) return
      this.update()
    }
  },
  methods: {
    update(){
      if (!this.chartData) return
      this.chartInstance.setOption({
        tooltip: {
          trigger: 'item',
          formatter: '{b} {d}% <br /> Pacientes: {c}'
        },
        legend: {
          orient: 'vertical',
          left: 'left',
        },
        series: [
          {
            name: '',
            type: 'pie',
            radius: this.chartRadius || '50%',
            data: this.chartData,
            emphasis: {
              focus: 'self',
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      });
    }
  }
};
</script>
